import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, List, ListItem, Divider, CircularProgress } from "@mui/material";
import studentApi from "../StudentApi";

function InactiveVouchersPage() {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Parse student data from localStorage
  const studentData = JSON.parse(localStorage.getItem("studentData"));
  const studentId = studentData?.id;

  useEffect(() => {
    if (!studentId) {
      setLoading(false);
      setError("Please log in to see your vouchers.");
      return;
    }

    const fetchVouchers = async () => {
      setLoading(true);
      try {
        const res = await studentApi.get(`/students/${studentId}/vouchers/inactive`);
        setVouchers(res.data.data || []);
      } catch (err) {
        console.error("Error fetching inactive vouchers:", err.response || err);
        setError("Failed to fetch vouchers. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchVouchers();
  }, [studentId]);

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Inactive Vouchers
      </Typography>

      {loading ? (
        <Box display="flex" alignItems="center" justifyContent="center" mt={3}>
          <CircularProgress />
          <Typography ml={2}>Loading inactive vouchers...</Typography>
        </Box>
      ) : error ? (
        <Typography color="error" mt={2}>{error}</Typography>
      ) : vouchers.length === 0 ? (
        <Typography mt={2}>No inactive vouchers found.</Typography>
      ) : (
        <Paper elevation={2}>
          <List>
            {vouchers.map((v, i) => (
              <React.Fragment key={v.id}>
                <ListItem sx={{ py: 2 }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{v.code}</Typography>
                    <Typography variant="body2" color="textSecondary">
                      {v.exam_name} / {v.subject_name} / {v.topic_name}
                    </Typography>
                  </Box>
                </ListItem>
                {i < vouchers.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
}

export default InactiveVouchersPage;
